import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { VproService } from './../service/vpro/vpro.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    constructor(private service: VproService, private router: Router) { }
    canActivate(route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): boolean {
        if (this.service.loggedIn()) {
            if(state.url.includes("login")){
            if(localStorage.getItem("LogUsrTyp") && localStorage.getItem("LogUsrTyp").indexOf("patient")!==-1){
                this.router.navigate(["/patient/members"]);
                return true;
            }
            else if(localStorage.getItem("LogUsrTyp") && localStorage.getItem("LogUsrTyp").indexOf("physician")!==-1){
                this.router.navigate(["/dashboard"]);
                return true;
            }
            }
            return true;
        } else {
            if(!state.url.includes("login")){
                this.router.navigate(['/login']);
            }
            else{
                return true;
            }
            return false;
        }
        return true;
    }
}
